module.exports = __webpack_public_path__ + "img/handbag.014ebf33.svg";